import { createContext, useContext } from 'react';

const ProUpgradeContext = createContext({
  isPro: true,
  isOwner: false,
  openProUpgrade: () => {},
});

export const useProUpgrade = () => useContext(ProUpgradeContext);

export default ProUpgradeContext;
